import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { branch, compose, renderComponent, defaultProps, renderNothing } from 'recompose';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../../components/buttons/button-with-icon';
import { InputGroup } from '../../../../components/inputs/input-group';
import { withDebouncedHandlers } from '../../../../helpers/hocs/with-debounced-handlers';
import { ConfigService } from '../../../../services/config-service';
import { UserService } from '../../../../services/user-service';
import { logout } from '../../../../store/reducers/account/actions';

const ShadowUserActions = React.memo(() => {
  const { login, signUp } = ConfigService.get('ACCOUNT.MAIN.buttons', {});

  return (
    <InputGroup>
      {login.show && <ButtonWithIcon to={login.to}>{login.label}</ButtonWithIcon>}
      {signUp.show && <ButtonWithIcon to={signUp.to}>{signUp.label}</ButtonWithIcon>}
    </InputGroup>
  );
});

const RegisteredUserActionsComponent = React.memo(({ logout, handleClick }) => (
  <InputGroup>
    <ButtonWithIcon type='negative' onClick={handleClick}>
      {logout.label}
    </ButtonWithIcon>
  </InputGroup>
));

const RegisteredUserActions = branch(
  () => UserService.hasUser(),
  compose(
    connect(null, { logoutAction: logout }),
    withRouter,
    defaultProps({ logout: ConfigService.get('ACCOUNT.MAIN.buttons.logout', {}) }),
    withDebouncedHandlers({
      handleClick:
        ({ logoutAction, history, logout }) =>
        () =>
          logoutAction(() => history.push(logout.to))
    })
  ),
  renderNothing
)(RegisteredUserActionsComponent);

export const AccountActions = branch(
  () => UserService.hasUser(),
  renderComponent(RegisteredUserActions)
)(ShadowUserActions);
